import {createSlice} from "@reduxjs/toolkit";
import json from "../../lib/appfuse-react/core/json";


const name = 'processingOperator';

const initialState = {
    data: [],
    selection: null,
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    drafts: {},
    nodeId: null,
    processingNodeId: 'confirmStatement',
    cropNodeId: 'applicantOrganicCertificationHistory'
}

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setSelection(state, action) {
            state.selection = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = json.toJSON(action.payload);
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setNodeId(state, action) {
            state.nodeId = action.payload;
        },
        setProcessingNodeId(state, action) {
            state.processingNodeId = action.payload;
        },
        setCropNodeId(state, action) {
            state.cropNodeId = action.payload;
        }
    }
})

export const { setDrafts, setPageNumber, setPageSize, setCriteria, setSelection, setSort, setNodeId, setProcessingNodeId, setCropNodeId } = slice.actions;
const {reducer} = slice;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => json.fromJSON(state[name].sort);
export const selectSelection = state => json.fromJSON(state[name].selection);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;

export const selectNodeId = state => state[name].nodeId;

export const selectProcessingNodeId = state => state[name].processingNodeId;
export const selectCropNodeId = state => state[name].cropNodeId;
export const selectOperatorDraft = (key) => (state) => selectDrafts(state)[key];

export const setOperatorDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

const processingOperatorReducer = reducer;
export default processingOperatorReducer;